export default __webpack_public_path__ + "images/radio-on.png";